"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useAddIconColor_1 = require("../../../hooks/useAddIconColor");
const StyledIconContainer = styled_components_1.default.div `
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconContainer = ({ icon }) => {
    const coloredIcon = (0, useAddIconColor_1.useAddIconColor)(icon);
    return react_1.default.createElement(StyledIconContainer, null, coloredIcon);
};
exports.IconContainer = IconContainer;
